import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse, ImagePreprocessingFunction } from 'types';

interface FetchImageProcessingParams {
  framework: string;
  frameworkVersion: string;
}

interface FetchImageProcessingResponse extends ApiResponse {
  framework: string;
  frameworkVersion: string;
  libraryVersion: string;
  functions: {
    [name: string]: ImagePreprocessingFunction;
  };
}

type FetchImageProcessing = (params: FetchImageProcessingParams) => Promise<FetchImageProcessingResponse>;

const fetchImageProcessing: FetchImageProcessing = async ({ framework, frameworkVersion }) => {
  const { data } = await apiClient.get(API_END_POINT.BLOCK.FETCH_IMAGE_PREPROCESSING, {
    params: {
      framework,
      frameworkVersion,
    },
  });

  return data;
};

export default fetchImageProcessing;
